// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/soc-frontend/" + chunkId + "." + {"4":"1d25ec22","49":"d4cfd88e","81":"7cce2ac0","223":"8902f4b6","325":"b70391f5","682":"e1d8e920","905":"3bbb2793","967":"a4f9a75e"}[chunkId] + ".chunk.js";
};